// extracted by mini-css-extract-plugin
module.exports = {"board_top_wrapper":"BoardTop_board_top_wrapper__1uHr_"};